import { render, staticRenderFns } from "./ButtonToggle.vue?vue&type=template&id=b6af6b80&scoped=true"
import script from "./ButtonToggle.vue?vue&type=script&lang=js"
export * from "./ButtonToggle.vue?vue&type=script&lang=js"
import style0 from "./ButtonToggle.vue?vue&type=style&index=0&id=b6af6b80&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6af6b80",
  null
  
)

export default component.exports